import {
    Box,
    Dialog,
    DialogProps,
    IconButton,
    Toolbar,
    Typography,
    Grid,
    Container,
} from "@mui/material";
import React from "react";
import {Close} from "@mui/icons-material";
import {LogoVertical} from "~/ui/icons";
import {SignInForm} from "./SignInForm";
import makeStyles from '@mui/styles/makeStyles';


export type SignInDialogFullscreenProps = Pick<DialogProps, "open" | "onClose"> & {
    onComplete?: () => void
}


const useStyles = makeStyles(theme => ({
    logo: {
        fontSize: 100,
    }
}));


export const SignInDialogFullscreen = (props: SignInDialogFullscreenProps) => {
    const { open, onClose, onComplete } = props;
    const classes = useStyles(props);

    return (
        <Dialog open={open} onClose={onClose} fullScreen={true}>
            <Toolbar>
                {onClose && (
                    <IconButton edge="start" onClick={e => onClose(e, "escapeKeyDown")} size="large">
                        <Close/>
                    </IconButton>
                )}
            </Toolbar>
            <Container>
                <Grid container alignItems="center" direction="column">
                    <LogoVertical className={classes.logo}/>

                    <Typography variant="headerTitle" marginTop="12px" color="primary">
                        Порт в кармане
                    </Typography>
                    <Typography variant="screenText" align="center" marginTop="32px" marginBottom="40px" color="primary">
                        Логин и пароль личного кабинета указан в договоре
                    </Typography>
                    <SignInForm onComplete={onComplete}/>
                </Grid>
            </Container>
        </Dialog>
    );
}